<Page name="gradedefinitions" 
  infinite
  infiniteDistance={30}
  infinitePreloader={showPreloader}
  onInfinite={loadMore}>
  <Header />
  <BlockTitle>Grade Definitions</BlockTitle>
  <Card>
    <CardHeader>
        What the Grades Mean and Suggestions for Practice
    </CardHeader>
    <CardContent>
        <p>The USPSTF updated its definition of and suggestions for practice for the grade C recommendation. This new definition applies to USPSTF recommendations voted on after July 2012. Describing the strength of a recommendation is an important part of communicating its importance to clinicians and other users. Although most of the grade definitions have evolved since the USPSTF first began, none has changed more noticeably than the definition of a C recommendation, which has undergone three major revisions since 1998. Despite these revisions, the essence of the C recommendation has remained consistent: at the population level, the balance of benefits and harms is very close, and the magnitude of net benefit is small. Given this small net benefit, the USPSTF has either not made a recommendation "for or against routinely" providing the service (1998), recommended "against routinely" providing the service (2007), or recommended "selectively" providing the service (2012). Grade C recommendations are particularly sensitive to patient values and circumstances. Determining whether or not the service should be offered or provided to an individual patient will typically require an informed conversation between the clinician and patient.</p>
    </CardContent>
  </Card>
  <Row><Footer/></Row>
</Page>
<script>
  import {
    Page,
    Navbar,
    NavLeft,
    NavRight,
    NavTitle,
    List,
    ListGroup,
    ListItem,
    Button,
    Preloader,
    Link,
    Block,
    Row,
    Col,
    SwipeoutActions,
    SwipeoutButton,
    BlockTitle,
    Card,
    CardContent,
    CardHeader
  } from 'framework7-svelte';
  import { pluralize } from '../utils';
  import Header from '../components/Header.svelte';
  import Footer from '../components/Footer.svelte';
  import { getContext, onDestroy } from 'svelte';
  import { query, searchData } from '../stores.js';

  let page = 1;
  let items;
  let currentItem;
  let allowInfinite = true;
  let showPreloader = false;
  let sQuery = '';
  let grade;
  let isShowFilter = true;

  let oData; 
  let oFilter;

  $: showPreloader = (items) ? (items.length < 299) ? true : false : false;
  $: fGroupTools();

  const unsubscribeSearchData = searchData.subscribe(obj => {
    oData = obj;
    fGroupTools(obj);
  });

  onDestroy(unsubscribeSearchData);

  function fGroupTools(obj) {

  }

  function loadMore() {
    if (!allowInfinite) return;
    allowInfinite = false;

    if (!showPreloader) return;
    
    page += 1;
  }
</script>
<style>
</style>